'use client'

import { useRouter } from 'next/navigation'
import styled from 'styled-components'

import HorizontalSeparator from '@/app/components/HorizontalSeparator'
import LoadingDecidechile from '@/app/components/LoadingDecidechile'
import MainTitleBase from '@/app/components/MainTitle'
import { useEnvironment } from '@/app/providers/EnvironmentProvider'
import { colors, spaces } from '@/config/global-parameters'

import reportAnalytics from '../components/analyticsEvents'
import CircumpscriptionSection from '../components/CircumscriptionSection'
import ComparadorRechazo from '../components/ComparadorRechazo'
import ListVotesPerElectionSection from '../components/ListVotesPerElection'
import ParticipationSection from '../components/ParticipationSection'
import WorkingPage from '../components/WorkingPage'
import { ICandidatosDataEnv } from '../providers/CandidatosDataProvider'
import { ILiveDataEnv } from '../providers/LiveDataProvider'
import ICandidato from '../types/ICandidato'
import GanadoresSummary from './components/GanadoresSummary'
import { IGanadorWithData } from './types/ganadores'

export type IResultadosConsejerosEnv = ICandidatosDataEnv & ILiveDataEnv

const ResultadosConsejeros = () => {
  const { push } = useRouter()
  const { electionData, liveData } = useEnvironment<IResultadosConsejerosEnv>()
  const {
    comparadorRechazo,
    evolucionPorLista,
    ganadores,
    lastUpdate,
    mesasEscrutadas,
    participacion,
    resultadosCandidatos,
  } = liveData
  const { candidatos } = electionData //mockCandidates

  if (process.env.NEXT_PUBLIC_WORKING_GENERAL) return <WorkingPage />

  if (
    !comparadorRechazo
    || !evolucionPorLista
    || !ganadores
    || !lastUpdate
    || !mesasEscrutadas
    || !participacion
    || !candidatos
    || !resultadosCandidatos
  )
    return <LoadingDecidechile />
  const ganadoresWithData: IGanadorWithData[] = ganadores && candidatos
    ? ganadores.map((ganador) => {
      const candidatoData = candidatos.find((candidato) => candidato.id === ganador.id) || ({} as ICandidato)
      return {
        ...ganador,
        ...candidatoData,
      }
    })
    : []

  const handleCircunscripcionClick = () => {
    push('/2023/consejo/circunscripciones/7')
    reportAnalytics('consejeros_ver_detalle_por_circunscripcion')
  }

  const candidatosWithData = resultadosCandidatos.map((resultadosCandidato) => {
    const candidato = candidatos?.find(
      (candidato) => candidato.id === resultadosCandidato.id_candidato
    ) as ICandidato
    return {
      ...resultadosCandidato,
      ...candidato,
      porcentaje: resultadosCandidato.percentage,
      votos: resultadosCandidato.votes,
    }
  })

  return (
    <Wrapper>
      <SummaryWrapper>
        <MainTitle updatedAt={lastUpdate} />
        <GanadoresSummary
          candidatosWithData={candidatosWithData}
          ganadores={ganadoresWithData}
        />
      </SummaryWrapper>
      <ButtonContainer>
        <DetailCircunscripcionButton onClick={handleCircunscripcionClick}>
          Ver detalle por circunscripción
        </DetailCircunscripcionButton>
      </ButtonContainer>
      <ParticipationSection participacion={participacion} />
      {/*<CountedTables mesasEscrutadas={mesasEscrutadas} />*/}
      <HorizontalSeparator />
      <ComparadorRechazo
        ganadores={candidatosWithData}
        ratioRechazoPlebiscito={comparadorRechazo.porcentaje_rechazo}
      />
      <HorizontalSeparator />
      <ListVotesPerElectionSection evolucionPorLista={evolucionPorLista} />
      <HorizontalSeparator />
      <CircumpscriptionSection
        candidatos={candidatos}
        ganadores={candidatosWithData}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spaces.l};
`

const SummaryWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${spaces.m};
  @media (max-width: ${spaces.tabletBreakpoint}) {
    gap: ${spaces.xxs};
  }
`

const MainTitle = styled(MainTitleBase)`
  padding-top: ${spaces.m};
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

const DetailCircunscripcionButton = styled.div`
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  background-color: ${colors.colorWhite};
  color: ${colors.decidechileBlue};
  border: 2px solid ${colors.decidechileBlue};
  padding: 8px 26px;

  :hover {
    background-color: ${colors.decidechileBlue};
    color: ${colors.colorWhite};
    border: 2px solid ${colors.decidechileBlue};
  }
`

export default ResultadosConsejeros
